import axios from 'axios';

// หน้าที่ Super Admin เปิด/ปิดให้แต่ละบริษัท (SuperAdmin → Organization Structure → แก้ไขหน่วยงาน)
// ค่า = route name = PageKey ฝั่ง backend (CompanyPagePermissionBal.ControlledPages) — เพิ่มหน้าใหม่ต้องแก้ทั้งสองฝั่ง
// คุมแค่การเข้าหน้า: NavBar ซ่อนเมนู + router เด้ง AccessDenied เมื่อพิมพ์ URL ตรง · ค่าที่ตั้งไว้ในหน้าและสิทธิ์ API ไม่เปลี่ยน
export const COMPANY_PAGE_KEYS = Object.freeze(['SettingExternalConnector', 'SetupSocial']);

// ผลของ CompanyPagePermission/MyPages → รายชื่อหน้าที่เข้าได้ · ตอบไม่สำเร็จ/รูปไม่ตรง = ไม่มีหน้าไหน (ปิดไว้ก่อน)
// SuperAdmin ได้ทุกหน้าจาก backend (อ่าน claim isSuperAdmin) — ไม่เชื่อ cookie/sessionStorage ฝั่ง client
export function allowedPagesFromResponse(body) {
  const pages = body?.status === 0 ? body.data?.allowedPages : null;
  return Array.isArray(pages) ? pages.filter((p) => typeof p === 'string') : [];
}

// สำหรับ router guard เท่านั้น — router เรียก $call ไม่ได้ (api/call.js import router อยู่แล้ว) · component ใช้ $call.GetMyCompanyPages
export function fetchAllowedCompanyPages() {
  return axios
    .get(`${import.meta.env.VITE_APP_API}api/v0/CompanyPagePermission/MyPages`, { withCredentials: true })
    .then((res) => allowedPagesFromResponse(res.data))
    .catch(() => []);
}
